import app from '../../forum/app';
import Notification from './Notification';
/**
 * The `DiscussionRenamedNotification` component displays a notification which
 * indicates that a discussion has had its title changed.
 */
export default class DiscussionRenamedNotification extends Notification {
  icon() {
    return 'fas fa-pencil-alt';
  }
  href() {
    const notification = this.attrs.notification;
    const discussion = notification.subject();
    if (!discussion) {
      return '#';
    }
    return app.route.discussion(discussion, notification.content().postNumber);
  }
  content() {
    return app.translator.trans('core.forum.notifications.discussion_renamed_text', {
      user: this.attrs.notification.fromUser()
    });
  }
  excerpt() {
    return null;
  }
}
flarum.reg.add('core', 'forum/components/DiscussionRenamedNotification', DiscussionRenamedNotification);